import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './SiteMap.css'; 
import 'font-awesome/css/font-awesome.min.css';

const SiteMap = () => {
  const mapContainerRef = useRef(null);

  useEffect(() => {
    const markerPosition = [17.4416, 78.3825];
    const map = L.map(mapContainerRef.current).setView(markerPosition, 15);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors & <a href="https://carto.com/attributions">CartoDB</a>',
      maxZoom: 19
    }).addTo(map);

    const customIcon = L.icon({
      iconUrl: 'https://e7.pngegg.com/pngimages/409/413/png-clipart-map-drawing-pin-map-marker-angle-heart.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });

    const marker = L.marker(markerPosition, { icon: customIcon }).addTo(map)
      .bindPopup('PRT SOFTWARE SOLUTIONS')
      .openPopup();

    marker.on('click', () => {
      window.open(`https://www.google.com/maps?q=${markerPosition[0]},${markerPosition[1]}`, '_blank');
    });

    map.on('click', () => {
      window.open(`https://www.google.com/maps?q=${markerPosition[0]},${markerPosition[1]}`, '_blank');
    });

    return () => {
      map.remove();
    };
  }, []);
 

  return (
    <div className="map-section">
       
      <div className="address-map-container">
        <div className='address-contact'>
          {/* <p>
            <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>
            +917569400921
          </p> */}
          <a href="mailto:support@skillzverse.com" className='mail-link'>
            <p>
              <i className="fa fa-envelope" style={{ marginRight: '8px' }}></i>
              support@skillzverse.com
            </p>
          </a>
        </div>

        <p>
          <i className="fa fa-map-marker" style={{ marginRight: '8px' }}></i>
          PRT Software Solutions, Serenity Square, 1-98/G/38, MindSpace, HITEC City, Hyderabad, Telangana 500081
        </p>
        <div ref={mapContainerRef} className="map"></div>
      </div>
    </div>
  );
};

export default SiteMap;
